(function ($) {
  Drupal.behaviors.discover_more_mobile = {
    attach: function (context, settings) {
      var MXLocale = $.cookie('LOCALE') ? 'es_MX' : null;

      if (MXLocale) {
        $('.js-spp-product__additional-section', context).removeClass('is_closed');
      }
      // discover more only two items for mobile
      if ($('.spp-discover-more-section-mobile .discover_more__product').length == 3) {
        $('.spp-discover-more-section-mobile .discover_more__product:last').remove();
      }
      function recalculateHeights() {
        setTimeout(function(){ // timeout to let fonts render - @font-face FOUT
          var containerHeight = $('.spp-discover-more-section-mobile .discover-more__mobile-slider').height();
          $('.spp-discover-more-section-mobile .discover_more__product').height(containerHeight);
        },120);
      }
      if ($('.spp-discover-more-section-mobile .discover_more__product').length == 2) {
        recalculateHeights();
      }

      //update row height on resize
      $( window ).resize( _.debounce( function(){
        $('.spp-discover-more-section-mobile .discover_more__product').removeAttr('style');
        if ($('.spp-discover-more-section-mobile .discover_more__product').length == 2) {
          recalculateHeights();
        }
      },200));
    }// attach
  };

})(jQuery);